"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLayoutRequiredServices = exports.defaultLayoutOptionalServices = void 0;
var _configurationManager = require("@ori/configuration-manager");
const defaultLayoutRequiredServices = exports.defaultLayoutRequiredServices = [_configurationManager.serviceSchema.Enum.clientApps, _configurationManager.serviceSchema.Enum.eshop, _configurationManager.serviceSchema.Enum.globalApi, _configurationManager.serviceSchema.Enum.graphQl, _configurationManager.serviceSchema.Enum.identity, _configurationManager.serviceSchema.Enum.mobileOfficeApi, _configurationManager.serviceSchema.Enum.online, _configurationManager.serviceSchema.Enum.staticApi, _configurationManager.serviceSchema.Enum.graphQlNet];
/** BotApi is not present in all regions and thus must be optional */
const defaultLayoutOptionalServices = exports.defaultLayoutOptionalServices = ['botApi', 'kpiApi'];
